import React, { useContext } from 'react';
import { Box, Column, Optional, Row } from '@honda-canada/design-system-react';
import ConfigurationProvider from './service/Provider';
import Context from './service/Context';
import Finance from './shared/Finance';
import InformationalApr from './shared/InformationalApr';
import OnlyFinance from './shared/OnlyFinance';
import PAYMENT_DETAILS_COMPONENT_TYPE from './constants';
import Terms from './shared/Terms';
import themeStyles from './PaymentDetailsComponent.styles';
const PaymentColumn = themeStyles.apply(Column, 'PaymentColumn');
const PaymentDetailsComponentUI = () => {
    const { onlyFinance, fullDetails } = useContext(Context);
    return (React.createElement(Box, { "component-type": PAYMENT_DETAILS_COMPONENT_TYPE },
        React.createElement(Optional, { when: onlyFinance },
            React.createElement(OnlyFinance, { componentType: PAYMENT_DETAILS_COMPONENT_TYPE })),
        React.createElement(Optional, { when: fullDetails },
            React.createElement(Row, { alignItems: "flex-end" },
                React.createElement(PaymentColumn, { width: [1 / 2], "data-testid": "cy-payment-frequency" },
                    React.createElement(Finance, null)),
                React.createElement(PaymentColumn, { width: [1 / 2], "data-testid": "cy-payment-term" },
                    React.createElement(Terms, null)),
                ' ',
                React.createElement(PaymentColumn, { width: [1, 1, 1], "data-testid": "cy-payment-informational-apr" },
                    React.createElement(InformationalApr, null))))));
};
const PaymentDetailsComponent = ({ appNameConfig }) => (React.createElement(ConfigurationProvider, { appNameConfig: appNameConfig },
    React.createElement(PaymentDetailsComponentUI, null)));
export default PaymentDetailsComponent;
